<template lang="pug">
form(@submit.prevent="navigate('sistema.docModelos.edit.calculo')")
  p.text-large - Parâmetros
  .columns
    .column.col-8.col-md-8.col-sm-12
      .columns
        .column.col-12
          form-group(
            label="Prazo para vencimento do débito",
            :validation="$v.resource.params.osm.prazo_vencimento_debito"
          )
            int.form-input(
              v-model.number="$v.resource.params.osm.prazo_vencimento_debito.$model"
            )
            .form-input-hint Em dias.
        .column.col-12
          form-group(
            label="Limite de autuações",
            :validation="$v.resource.params.osm.limite_autuacao"
          )
            int.form-input(
              v-model.number="$v.resource.params.osm.limite_autuacao.$model"
            )
            .form-input-hint Se não informado será sem limite (infinito).
        .column.col-12
          form-group(
            label="Mínimo de fotos",
            :validation="$v.resource.params.osm.minimo_fotos"
          )
            int.form-input(
              v-model.number="$v.resource.params.osm.minimo_fotos.$model"
            )
            .form-input-hint Quantidade mínima de fotos ao emitir.
        .column.col-12
          form-group(
            :label="'doc_modelo.prazo' | tModel",
            :validation="$v.resource.prazo"
          )
            int.form-input(v-model.number="$v.resource.prazo.$model")
            .form-input-hint Prazo para regularizar em dias.
        .column.col-12
          form-group(
            :label="'doc_modelo.pontuacao' | tModel",
            :validation="$v.resource.pontuacao"
          )
            money.form-input(v-model.number="$v.resource.pontuacao.$model")
        .column.col-12
          form-group(
            label="Dias para abrir OS-m de verificar regularização após vencer o prazo",
            :validation="$v.resource.params.osm.osm_verificar_apos_dias"
          )
            int.form-input(
              v-model.number="$v.resource.params.osm.osm_verificar_apos_dias.$model"
            )
            .form-input-hint Dias após vencido o prazo de regularização para abertura automatica da OS-m de verificação.
        .column.col-12
          form-group(
            :label="'doc_modelo.debito_tipo' | tModel",
            :validation="$v.resource.debito_tipo_id"
          )
            debito-tipo-picker(
              v-model="$v.resource.debito_tipo_id.$model",
              @selected="onSelectDebitoTipo"
            )
        .column.col-12
          form-group(
            :label="'doc_modelo.situacao_na_ciencia' | tModel",
            :validation="$v.resource.situacao_na_ciencia_id"
          )
            select.form-select(
              v-model="$v.resource.situacao_na_ciencia_id.$model"
            )
              option(
                v-for="situacao in situacoesNaCiencia",
                :value="situacao.id"
              ) {{ situacao.descricao }}
            .form-input-hint Situação que vai o Documento no momento da ciência
        .column.col-12
          form-group(
            label="Texto para implantar o documento",
            :validation="$v.resource.params.osm.texto_para_implantar"
          )
            input.form-input(
              v-model.number="$v.resource.params.osm.texto_para_implantar.$model",
              maxlength="255"
            )
            .form-input-hint Texto de observação do lançamento do débito no tributário
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.params.osm.permite_defesa.$model"
              )
              i.form-icon
              | Permite solicitar defesa do Documento
              .form-input-hint Permite ao contribuinte solicitar defesa pelo Acesso Cidadão.
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.params.osm.permite_mesmo_em_andamento.$model"
              )
              i.form-icon
              | Permite emitir mesmo com Documentos em andamento
              .form-input-hint Emitir novo Documento mesmo existindo outro em andamento para o mesmo cadastro e modelo.
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.ciencia_automatica.$model"
              )
              i.form-icon
              | {{ "doc_modelo.ciencia_automatica" | tModel }}
              .form-input-hint Vai dar ciência automaticamente se o contribuinte tem acesso ao sistema e não deu cieência no prazo.
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.autua_automaticamente.$model"
              )
              i.form-icon
              | {{ "doc_modelo.autua_automaticamente" | tModel }}
              .form-input-hint Vai autuar quando vencer o prazo para regularizar.
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.implantar_na_ciencia.$model"
              )
              i.form-icon
              | Implantar automaticamente ao dar ciência no documento
              .form-input-hint Vai gerar o PAF e implantar no tributário.
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.implantar_ao_autuar.$model"
              )
              i.form-icon
              | Implantar automaticamente ao autuar o documento
              .form-input-hint Vai gerar o PAF e implantar no tributário.
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.params.osm.vistoria_mesmo_fiscal.$model"
              )
              i.form-icon
              | Vistoria pelo mesmo fiscal
              .form-input-hint Exigir que a vistoria seja realizada pelo fiscal emissor do Documento.
        .column.col-12
          .form-group
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.resource.params.osm.bloqueia_fundo_vale.$model"
              )
              i.form-icon
              | Bloqueia cadastro de fundo de vale
              .form-input-hint Não permite emitir Documento para cadastro do tipo fundo de vale.
  .pt-2
    .divider
    button.btn.btn-primary(:disabled="$v.resource.$invalid")
      btn-content(name="next")
</template>

<script>
import editMixin from "./mixin"
import { minValue, required } from "vuelidate/lib/validators"

export default {
  mixins: [editMixin],
  methods: {
    onSelectDebitoTipo(debitoTipo) {
      this.resource.debito_tipo = debitoTipo
    },
  },
  computed: {
    situacoesNaCiencia() {
      return [
        { id: null, descricao: "Regra padrão do sistema" },
        { id: 2, descricao: "Notificado" },
        { id: 12, descricao: "Autuado" },
        { id: 13, descricao: "Aguardando Regularizar" },
      ]
    },
  },
  validations: {
    resource: {
      prazo: { required, minValue: minValue(0) },
      pontuacao: { required, minValue: minValue(0) },
      tipo_implantacao: { required },
      autua_automaticamente: { required },
      implantar_na_ciencia: { required },
      implantar_ao_autuar: { required },
      ciencia_automatica: { required },
      debito_tipo_id: {},
      situacao_na_ciencia_id: {},
      params: {
        osm: {
          texto_para_implantar: {},
          minimo_fotos: { required, minValue: minValue(0) },
          limite_autuacao: { minValue: minValue(0) },
          permite_mesmo_em_andamento: {},
          permite_defesa: {},
          vistoria_mesmo_fiscal: {},
          bloqueia_fundo_vale: {},
          osm_verificar_apos_dias: {},
          prazo_vencimento_debito: { required, minValue: minValue(0) },
        },
      },
    },
  },
}
</script>
